import React from 'react';
import { Search, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

/**
 * Search + category filter + add-product button — pure presentation.
 */
const ProductFilters = ({
  searchTerm,
  setSearchTerm,
  filterCategory,
  setFilterCategory,
  categories,
  onAddProduct,
}) => (
  <div className="flex gap-4 mb-6 flex-wrap">
    <div className="relative flex-1 max-w-xs">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
      <Input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search products..."
        className="pl-10"
        data-testid="product-search"
      />
    </div>
    <select
      value={filterCategory}
      onChange={(e) => setFilterCategory(e.target.value)}
      className="px-3 py-2 border rounded-md"
      data-testid="category-filter"
    >
      <option value="">All Categories</option>
      {categories.map((cat) => (
        <option key={cat._id} value={cat.slug}>{cat.name}</option>
      ))}
    </select>
    <Button onClick={onAddProduct} data-testid="add-product-btn">
      <Plus className="h-4 w-4 mr-2" /> Add Product
    </Button>
  </div>
);

export default ProductFilters;
